import { render, staticRenderFns } from "./IconClients.vue?vue&type=template&id=9094f508&"
import script from "./IconClients.vue?vue&type=script&lang=js&"
export * from "./IconClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports